import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import {A11yModule} from '@angular/cdk/a11y';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-together-lightbox',
  standalone: true,
  imports: [A11yModule, MatIcon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (open) {
      <div
        class="lightbox"
        role="dialog"
        aria-modal="true"
        cdkTrapFocus
        [attr.aria-label]="'together.lightbox.aria' | translate: {titel: titel}"
        (click)="onBackdropClick($event)"
        (keydown.escape)="close.emit()"
      >
        <button
          #closeBtn
          class="lightbox__close"
          type="button"
          [attr.aria-label]="'together.lightbox.close' | translate"
          (click)="close.emit()"
        >
          <mat-icon fontIcon="close"></mat-icon>
        </button>
        <figure class="lightbox__figure" (click)="$event.stopPropagation()">
          <img
            class="lightbox__img"
            [src]="imageUrl"
            alt=""
          />
          <figcaption class="lightbox__caption">
            <span class="lightbox__caption-title">{{ titel }}</span>
            @if (beschreibung && beschreibung !== titel) {
              <span class="lightbox__caption-desc">{{ beschreibung }}</span>
            }
          </figcaption>
        </figure>
      </div>
    }
  `,
  styleUrl: './together-lightbox.component.scss',
})
export class TogetherLightboxComponent implements OnChanges {
  @Input() open = false;
  @Input() imageUrl: string | null = null;
  @Input() titel = '';
  @Input() beschreibung: string | null = null;
  @Output() readonly close = new EventEmitter<void>();

  @ViewChild('closeBtn') closeBtn?: ElementRef<HTMLButtonElement>;

  ngOnChanges(): void {
    if (this.open) {
      setTimeout(() => this.closeBtn?.nativeElement.focus());
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
